import React, {createRef, Fragment, useRef} from 'react';
import autobind from 'autobind-decorator';
import {Col, Form, FormControl, Row} from 'react-bootstrap';

import {service as AuthService} from '../../Services/Core/AuthService';
import {ConfirmationDialog} from './ConfirmationDialog';

import {SB_ENTER_KEY_CODE} from '../../Constants';
import {Conditional} from "../Conditional";
import {config} from "../../Config";
import {KeyboardUtils} from "../../Utils";

export class ForgotPasswordPopup extends React.Component {
    constructor(props) {
        super(props);

        this.usernameInputRef = createRef();

        this.state = {
            email: '',
            error: '',
            success: ''
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //If we just ran an update to show the popup. Lets set focus and select the text of the input.
        if(this.props.Display && !prevProps.Display) {

            if(this.props.SuggestedEmail) {
                this.setState({email: this.props.SuggestedEmail}, () => {
                    if(this.input) {
                        this.input.focus();
                        this.input.select();
                    }
                });
            }
        }
    }

    @autobind
    submit(e) {
        e?.preventDefault();
        let me = this;
        let email = this.props.DefaultEmail || this.state.email;

        if(email) {
            AuthService.ForgotPassword(email)
                .then((x) => {
                    if(x.success) {
                        me.setState({success: "An email was sent to " + email, error: ''}, () => me.close());
                    } else {
                        me.setState({error: x.message || "Unknown error"}, () => me.close());
                    }
                })
                .catch((x) => {
                    me.setState({error: x?.data?.message ?? x?.message ?? "Unknown error"});
                });
        }
    }

    @autobind
    close() {
        if(this.props.Close) {
            this.setState({email: ''}, () => this.props.Close());
        }
    }

    @autobind
    updateEmail(event) {
        this.setState({ email: event.target.value });
    }

    @autobind
    getBody() {
        const {DefaultEmail} = this.props;
        return  <Form>
                    <Row key={1}>
                        <Col xs={12}>
                            <p>
                                {
                                    DefaultEmail ?
                                        ("Click 'Send Reset Password Email' to send a unique reset password link to " + DefaultEmail + "."):
                                        "Please enter your email and press 'Send Reset Password Email' to get a unique reset password link."
                                }
                            </p>
                        </Col>
                    </Row>
                    <Conditional Condition={config.getEnvironment() !== 'prod'}>
                        <Row key={3}>
                            <Col xs={12}>
                                <p className="sb-login-popup-container-error-message">This feature is disabled on this server. Please contact <a href="mailto:support@streambank.com">support@streambank.com</a> for assistance.</p>
                            </Col>
                        </Row>
                    </Conditional>
                    <Conditional Condition={!DefaultEmail}>
                        <Row key={2}>
                            <Col md={3}>
                                <span>Email</span>
                            </Col>
                            <Col md={9}>
                                <FormControl
                                    autoComplete="username"
                                    type="text"
                                    name="text"
                                    value={this.state.email}
                                    onChange={this.updateEmail}
                                    onKeyPress={(e) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, e, (e) => this.submit(e))}
                                    ref={this.usernameInputRef}
                                />
                            </Col>
                        </Row>
                    </Conditional>
                </Form>;
    }

    render() {
        let email = this.props.DefaultEmail || this.state.email;
        let popupBody = this.getBody();

        return <Fragment>
            <ConfirmationDialog
                Title="Success"
                Body={<p>{this.state.success}</p>}
                ConfirmationButtonMessage="OK"
                Display={!!this.state.success}
                OnConfirm={() => this.setState({success: ""})}
                className="sb-login-popup-container"
            />
            <ConfirmationDialog
                Title="Error"
                Body={<p>{this.state.error}</p>}
                ConfirmationButtonMessage="OK"
                Display={!!this.state.error}
                OnConfirm={() => this.setState({error: ""})}
                OnHide={() => this.setState({error: ""})}
                className="sb-login-popup-container"
            />
            <ConfirmationDialog
                Title="Forgot Password"
                Body={popupBody}
                CancelButtonMessage="Cancel"
                ConfirmationButtonMessage="Send Reset Password Email"
                DisableConfirmationButton={email === ""}
                Display={this.props.Display && !this.state.error && !this.state.success}
                OnClose={this.close}
                OnConfirm={(e) => this.submit(e)}
                className="sb-login-popup-container"
            />
        </Fragment>;
    }
}


